import { DocumentNode, gql } from "@apollo/client";

class HeapAnalyticDataService {
  public static getDrawRequestDataForHeapEvent = (): DocumentNode => gql`
    query GetDrawRequestDataForHeapEvent($payload: DrawRequestInputPayload!) {
      getDrawRequestDataForHeapEvent(payload: $payload) {
        identity
        test_name
        job_type
        public_order_uid
        lims_clinic_id
        business_unit
        tests_ordered
        draw_coordinator
      }
    }
  `;
}

export default HeapAnalyticDataService;
